import { atcBaseUrl } from '@/constants/config';
type loaderProps = {
  src: string;
}
export default function atcLoader({ src }: loaderProps) {
  return `${atcBaseUrl}/${src}`;
}
